import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from '@/providers/AppProviders';
import { AppRouter } from '@/routes/AppRouter';
import { initializeAuthSession } from '@/lib/auth/auth-session';
import '@/styles/globals.css';

async function bootstrap() {
  try {
    await initializeAuthSession();
  } catch (error) {
    console.error('[auth] Failed to initialize auth session', error);
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </React.StrictMode>
  );
}

bootstrap();
